import React from 'react';
import { FormControlLabel, RadioGroup, Box } from '@material-ui/core';
// ? components
import { RadioSelect } from '../../components/RadioButtons';
// ? store
import CreateContext from '../../store/CreateContext';
import { withNamespaces } from 'react-i18next';

function ReportTypeComponent(props) {
  const context = React.useContext(CreateContext);
  return (
    <div className='col-xs-12 col-md-6  col-lg-6 pb-2'>

      <RadioGroup className='ml-3' row aria-label='report-type' name='report-type'
        value={context.report_type}
        style={{ fontSize: "12px" }}
        onClick={(evt) => { if (evt.target.value) context.onChangeType(evt.target.value); }}>
        <FormControlLabel
          style={{ fontSize: "12px" }}
          value='ondemand'
          control={<RadioSelect />}
          label={
            <Box component="div" fontSize={12}>
              {props.t("on_demand")}
            </Box>
          }

        />
        <FormControlLabel
          style={{ fontSize: "12px" }}

          value='scheduled'
          control={<RadioSelect />}
          label={
            <Box component="div" fontSize={12}>
              {props.t("programmed")}
            </Box>
          }
        />
      </RadioGroup>
    </div>
  );
}

export default withNamespaces()(ReportTypeComponent);